/**
 * Ryan O'Dowd
 * 2023-12-29
 * © Copyright 2023 Oakwood Software Consulting, Inc. All Rights Reserved.
 */

const getStyles = ({globalScale, colors}) => {
  return {
    textWrapper: {
      flex: 1,
      alignItems: 'flex-start',
      justifyContent: 'flex-start',
      color: colors.white,
    },
    title: {
      fontSize: globalScale * 18,
      color: colors.white,
    },
    subtitle: {
      flexWrap: 'wrap',
      fontSize: globalScale * 14,
      color: colors.white,
    },
    action: {
      padding: globalScale * 4,
      alignItems: 'flex-end',
      justifyContent: 'center',
    },
    rowWrapper: {
      flexDirection: 'row',
    },
  };
};

export default getStyles;
